import orderQueries from '@apis/queries/orderQueries';
import projectQueries from '@apis/queries/projectQueries';
import useTestUser from '@hooks/test/useTestUser';
import { useQuery } from '@tanstack/react-query';

function useRecentOrders() {
    const { data } = useQuery(orderQueries.recent());
    const isTestUser = useTestUser();
    const { data: testShopResponse } = useQuery(projectQueries.testShops());
    return data?.orders.filter((order) => {
        const { shopId } = order;
        if (testShopResponse?.shopIds?.includes(shopId)) {
            return isTestUser;
        }
        return true;
    });
}

export default useRecentOrders;
